import * as angular from "angular"
import { FieldViewModel, ICropping, IField, IOmniaCommand } from "../omnia"
import { commands } from "../strings"
import { IFieldsModuleContext } from "../types"

const cmd = commands

type Context = Omit<IFieldsModuleContext, "map" | "mapView">

export class EditCmd implements IOmniaCommand {

    protected _editTarget: IField | ICropping

    constructor(
        protected ctxt: Context,
        protected fields: boolean,
        protected _create: boolean,
        public text: string,
        public icon: string,
        public foreground: boolean = false,
        public readOnly = ctxt.readOnly
    ) {
    }

    get editTarget(): IField | ICropping {
        return this._editTarget
    }

    get create(): boolean {
        return this._create
    }

    get update(): boolean {
        return !this._create
    }

    get editFields(): boolean {
        return this.fields
    }

    get editCroppings(): boolean {
        return !this.fields
    }

    canExecute(field?: FieldViewModel) {
        return field ? (!field.disabled) : true
    }

    execute(item?: FieldViewModel) {

        if (item) {
            this.ctxt.svc.selectItems([item], true)
        }

        var target: FieldViewModel = item ? item : <FieldViewModel>{}

        this._editTarget = <any>{}


        if (target && target.field) {

            this._editTarget = <any>angular.extend({}, target.isCropping() ? target.cropping : target.field)

            if (target.isCropping() && target.cropping.Composition) {

                const composition = target.cropping.Composition.map(c => ({
                    CropId: c.CropId,
                    Percentage: c.Percentage
                }));

                (<any>this._editTarget).Composition = composition

            }

        }

        var component = (this.editFields ? "omnia-fields-edit-fields" : "omnia-fields-edit-croppings")

        this.ctxt.startComponent({ component: component, execArguments: this })

        return true

    }

    isActive(): boolean {
        // You can't click edit if we're already in the process of editing something.
        return !this.ctxt?.editSvc?.isEditing;
    }

}

export class UpdateCmd extends EditCmd {

    constructor(
        ctxt: Context,
        fields: boolean,
        text: string,
        icon: string = "edit",
        foreground: boolean = false) {

        super(ctxt, fields, false, text, icon, foreground)

    }

    execute(field: FieldViewModel) {
        return super.execute(field)
    }

}


export class CreateFieldsCmd extends EditCmd {

    constructor(ctxt: IFieldsModuleContext) {
        super(ctxt, true, true, cmd.newField, "fas fa-plus")
    }

    canExecute(field?: FieldViewModel) {
        return !this.readOnly
    }

}

export class UpdateFieldsCmd extends UpdateCmd {

    constructor(ctxt: Context, text: string = cmd.editFields, foreground = true) {
        super(ctxt, true, text, "fas fa-pen", foreground)
    }

}


export class CreateCroppingCmd extends EditCmd {

    previousCropping: FieldViewModel

    constructor(ctxt: Context, text: string = cmd.newCropping) {
        super(ctxt, false, true, text, "fas fa-plus")
    }

    canExecute(field: FieldViewModel) {
        return field && (!field.disabled) && (!this.readOnly)
    }

    execute(vm: FieldViewModel) {

        const newCropping = <ICropping>{}

        if (vm) {
            newCropping.Field = vm.field
            newCropping.FieldId = vm.fieldId
            if (vm.isCropping()) this.previousCropping = vm
        }

        this._editTarget = newCropping

        this.ctxt.startComponent({ component: "omnia-fields-edit-croppings", execArguments: this })

        return true

    }

}

export class UpdateCroppingsCmd extends UpdateCmd {

    constructor(ctxt: Context, text: string = cmd.editCropping) {
        super(ctxt, false, text, "fas fa-pen", true)
    }

}
